import axios from "../../services/axios.config";

const endpoints = {
  addTeamMember: `api/users/create-new-user/`,
  getAllTeamMembers: `api/users/team-members/`,
  getTeamMemberDetail: `api/users/team-members/team-member-detail/`,
  deleteTeamMember: `api/users/team-members/delete-member/`,
  editTeamMember: `api/users/team-members/edit-member-profile/`,
  togglePublishFlag: `api/users/team-members/toggle-publish/`,
  toggleWorkingFlag: `api/users/team-members/toggle-working/`,
  getMemberNameList: `api/users/team-members/list/`,
};
const state = {
  teams: [],
  teamMemberDetail: {},
  teamMemberNameList: [],
};

const getters = {
  getTeamList: (state) => state.teams,
  getTeamMemberDetail: (state) => state.teamMemberDetail,
  getTeamNameList: (state) => state.teamMemberNameList,
};

const actions = {
  createTeamAccount({commit}, userData) {
    return new Promise((resolve, reject) => {
      axios
        .post(endpoints.addTeamMember, {
          first_name: userData.firstName,
          username: userData.userName,
          email: userData.emailAddress,
          password: userData.passWord,
        })
        .then((response) => {
          commit("addNewMember", response.data);
          resolve(response);
        })
        .catch((err) => reject(err));
    });
  },

  fetchTeamList({commit}, options = {}) {
    return new Promise((resolve, reject) => {
      commit("setTeamList", []);
      const q = options.includeNotWorking ? "?include_not_working=1" : "";
      axios
        .get(endpoints.getAllTeamMembers + q)
        .then((response) => {
          commit("setTeamList", response.data);
          resolve(response);
        })
        .catch((err) => reject(err));
    });
  },
  fetchTeamNameList({commit}, options = {}) {
    return new Promise((resolve, reject) => {
      const q = options.includeNotWorking ? "?include_not_working=1" : "";
      axios
        .get(endpoints.getMemberNameList + q)
        .then((response) => {
          commit("setTeamNameList", response.data);
          resolve(response);
        })
        .catch((err) => reject(err));
    });
  },

  fetchTeamDetail({commit}, value) {
    return new Promise((resolve, reject) => {
      axios
        .get(endpoints.getTeamMemberDetail + value.id)
        .then((response) => {
          commit("setTeamMemberDetail", response.data);
          resolve(response);
        })
        .catch((err) => reject(err));
    });
  },

  editTeamMember: ({commit}, team) => {
    return new Promise((resolve, reject) => {
      axios
        .put(endpoints.editTeamMember + `${team.id}`, team.teamForm)
        .then((response) => {
          commit("updateTeamMember", team.teamForm);
          resolve(response);
        })
        .catch((err) => reject(err));
    });
  },
  deleteTeamMember: ({commit}, team) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(endpoints.deleteTeamMember + `${team.id}`)
        .then((response) => {
          commit("deleteTeamMemberData", team.id);
          resolve(response);
        })
        .catch((err) => reject(err));
    });
  },

  toggleMemberPublishFlag({commit}, value) {
    return new Promise(() => {
      axios
        .put(endpoints.togglePublishFlag + value.memberId, {
          publish: value.publish,
        })
        .then(() => {
          const publish = value.publish;
          const memberId = value.memberId;
          commit("updateTeamPublishToggle", {publish, memberId});
        });
    });
  },

  toggleMemberWorkingFlag({commit}, value) {
    return new Promise((resolve, reject) => {
      axios
        .put(endpoints.toggleWorkingFlag + value.memberId, {
          is_currently_working: value.isCurrentlyWorking,
        })
        .then(() => {
          commit("updateTeamWorkingToggle", {
            memberId: value.memberId,
            isCurrentlyWorking: value.isCurrentlyWorking,
          });
          resolve();
        })
        .catch((err) => reject(err));
    });
  },
};
const mutations = {
  setTeamList: (state, teamsData) => (state.teams = teamsData),
  setTeamNameList: (state, teamsData) => (state.teamMemberNameList = teamsData),
  setTeamMemberDetail: (state, teamMemberDetailData) =>
    (state.teamMemberDetail = teamMemberDetailData),

  addNewMember: (state, payload) => {
    state.teams.push(payload);
  },

  updateTeamMember: (state, data) => {
    state.teams = state.teams.map((item) => {
      return item.id === data.id ? data : item;
    });
  },

  updateTeamPublishToggle: (state, {publish, memberId}) => {
    state.teams = state.teams.map((item) => {
      if (item.id === memberId) {
        item.publish = publish;
      }
      return item;
    });
  },

  updateTeamWorkingToggle: (state, {memberId, isCurrentlyWorking}) => {
    state.teams = state.teams.map((item) => {
      if (item.id === memberId) {
        item.is_currently_working = isCurrentlyWorking;
      }
      return item;
    });
  },

  deleteTeamMemberData: (state, id) => {
    const i = state.teams.findIndex((item) => {
      if (item.id !== id) return;
      return id;
    });
    if (i === -1) return;
    state.teams.splice(i, 1);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
